<template>
    <router-view v-slot="{ Component }">
        <component :is="Component || 'Trips'" />
    </router-view>
</template>

<script>
import Trips from '@/components/trips/trips.vue';
export default {
    name: 'TripsEntry',
    components: { Trips },
};
</script>
